const initFrontScript = () => {

	
	const initPage = () => {
		
	};

	if ( document.readyState !== 'loading' ) {
		initPage();
	} else {
		document.addEventListener( 'DOMContentLoaded', initPage );
	}

};

export default initFrontScript;